import { render } from "./ValidationPassRateMatrixTable.vue?vue&type=template&id=77c487cc"
import script from "./ValidationPassRateMatrixTable.vue?vue&type=script&lang=js"
export * from "./ValidationPassRateMatrixTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__